module.exports = __webpack_public_path__ + "static/davidlevy_avatar_linkedin-37a619571d75b8eb784d68e5ba7e7502.jpg";